var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Field, Input, PasswordRulesPopover, SubmitButton } from "../../components/components.js";
import { useRegister } from "../../core/auth.js";
import { filterChinese, isEmail, validatePassword } from "../../core/password.js";
import { setAuthCookie } from "../../core/session.js";
import { useEmailCode } from "../../hooks/useEmailCode.js";
import { buildProfileCompleteUrl } from "../../utils.js";
import { createPasswordValidator } from "../password-rules.js";
export const RegisterForm = ({ config, locale, options, returnUrl, setAction, showToast, t, onClose, }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [loading, registerApi] = useRegister();
    const isDisabled = useMemo(() => !(email.trim() && code.trim() && password.trim()), [email, code, password]);
    const { count, sendCode } = useEmailCode({
        t,
        action: "register",
        email,
        locale,
        showError: showToast,
    });
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!isEmail(email)) {
            showToast(t("register.validEmail"));
            return;
        }
        const passwordError = validatePassword(password);
        if (passwordError) {
            showToast(t(passwordError === "length" ? "passwordRules.length_error" : "passwordRules.composition"));
            return;
        }
        yield registerApi({
            values: { email, password, verifyCode: code, locale, returnUrl, source: (_a = config.source) !== null && _a !== void 0 ? _a : "" },
            onSuccess: (result) => {
                showToast({
                    type: "success",
                    content: t("register.registerSuccess"),
                });
                setAuthCookie(config, result.data.token, { temporary: true });
                setTimeout(() => {
                    var _a;
                    onClose("success");
                    (_a = options.onRegisterSuccess) === null || _a === void 0 ? void 0 : _a.call(options, result);
                    window.location.href = buildProfileCompleteUrl(config.userCenterUrl, locale, returnUrl);
                }, 1000);
            },
            onError: (msg) => {
                var _a;
                showToast({
                    type: "error",
                    content: msg,
                });
                (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, { message: msg });
            },
        });
    });
    return (_jsxs(_Fragment, { children: [_jsxs("h2", { className: "modalTitle modal", children: [" ", t("register.title")] }), _jsx(Field, { label: t("register.emailAddress"), rules: [
                    { required: true, message: t("register.requireEmail") },
                    { type: "email", message: t("register.validEmail") },
                ], children: _jsx(Input, { placeholder: t("register.emailAddress"), value: email, autoFocus: true, onChange: (value) => setEmail(value.trim()) }) }), _jsx(Field, { label: t("register.emailCode"), rules: [{ required: true, message: t("register.requireCode") }], children: _jsxs("div", { className: "smm-auth-input-row", children: [_jsx(Input, { placeholder: t("register.emailCode"), value: code, onChange: (value) => setCode(value.trim()) }), _jsx("button", { className: "smm-auth-send", type: "button", "data-smm-auth-tab-stop": "true", disabled: !email || count > 0 || loading, onClick: sendCode, children: count > 0 ? `${t("register.resend")}(${count}${t("register.s")})` : t("register.send") })] }) }), _jsx(Field, { label: t("register.password"), rules: [{ required: true, message: t("register.requirePassword") }, { validator: createPasswordValidator(t) }], children: _jsx(PasswordRulesPopover, { t: t, children: _jsx(Input, { placeholder: t("register.password"), type: "password", value: password, transformValue: filterChinese, onChange: setPassword }) }) }), _jsx(SubmitButton, { disabled: isDisabled, loading: loading, onClick: submit, children: t("register.continue") }), _jsxs("div", { className: "smm-auth-bottom", children: [t("register.hasAccount"), " ", _jsx("button", { className: "smm-auth-link smm-auth-sign-up", type: "button", onClick: () => setAction("login"), children: t("register.signIn") })] })] }));
};
//# sourceMappingURL=index.js.map